import { render, staticRenderFns } from "./AnimatedPrice.vue?vue&type=template&id=0c7dad9c&scoped=true&"
import script from "./AnimatedPrice.vue?vue&type=script&lang=js&"
export * from "./AnimatedPrice.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedPrice.vue?vue&type=style&index=0&id=0c7dad9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7dad9c",
  null
  
)

export default component.exports